import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface IStepCopyContainer {
    heading: string;
    subHeading: React.ReactNode;
    forceGutterBottom?: boolean;
}

const StepCopyContainer = ({ heading, subHeading, forceGutterBottom }: IStepCopyContainer) => (
    <Stack
        className="buying-online-steps--copy-container"
        spacing={{ xs: 1, sm: 2 }}
        useFlexGap
        sx={{
            mb: { lg: forceGutterBottom ? 14 : 0 },
            width: { lg: '24.5rem' },
        }}
    >
        <Typography component="h2" variant="h5" sx={{ typography: { sm: 'h4' } }}>
            {heading}
        </Typography>
        <Typography
            component="p"
            variant="h5"
            color="textSecondary"
            sx={{
                typography: { sm: 'h4' },
                '& sup': { ml: -0.5, fontSize: { xs: '1rem', sm: '1.4rem' } },
            }}
        >
            {subHeading}
        </Typography>
    </Stack>
);

export default StepCopyContainer;
